import ExcelJS from "exceljs";

const extractExcelFunction = async (data, filename) => {
  const cleanData = (data) => {
    return data.map((obj) => {
      return Object.entries(obj).reduce((acc, [key, value]) => {
        if (typeof value === "string" && /(R\$|%)/.test(value)) {
          const cleanedValue = value.replace(/(R\$|%|\.)/g, "");
          const formattedValue = cleanedValue.replace(",", ".");

          acc[key] = parseFloat(formattedValue);
        } else {
          acc[key] = value;
        }
        return acc;
      }, {});
    });
  };

  let exportData = await cleanData(data);
  let exportFilename = filename;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet1");
  worksheet.columns = Object.keys(exportData[0]).map((key) => ({
    header: key,
    key,
  }));
  worksheet.addRows(exportData);

  worksheet.eachRow((row) => {
    let isBoldRow = false;
    row.eachCell((cell) => {
      let cellValue = cell.value.toString();

      // Regular expression for the unified <style> tag
      const styleRegex = /<style\s*(.*?)>(.*?)<\/style>/g;
      const styleMatch = styleRegex.exec(cellValue);

      if (styleMatch) {
        const styleAttributes = styleMatch[1];
        const text = styleMatch[2];

        let font = {
          name: "SansSerif",
          size: 9,
          bold: false,
          italic: false,
          color: { argb: "000000" },
        };
        let alignment = { vertical: "top", horizontal: "left" };

        let isDate = false;
        let isNumber = false;

        const attributes = styleAttributes.split(" ");
        attributes.forEach((attr) => {
          if (attr === "bold") {
            font.bold = true;
            isBoldRow = true;
          } else if (attr === "italic") {
            font.italic = true;
          } else if (attr.startsWith("size=")) {
            font.size = parseInt(attr.split("=")[1], 10);
          } else if (attr.startsWith("color=")) {
            font.color = { argb: attr.split("=")[1].replace("#", "") };
          } else if (attr.startsWith("valign=")) {
            alignment.vertical = attr.split("=");
          } else if (attr.startsWith("halign=")) {
            alignment.horizontal = attr.split("=");
          } else if (attr.startsWith("numFmt=")) {
            const numFmtArr = attr.split("=")[1];

            const numFmtType = numFmtArr.split(":")[0];
            const numFmtVar = numFmtArr.split(":")[1];

            if (numFmtType === "date") {
              isDate = true;
            } else if (numFmtType === "number") {
              isNumber = true;
            }

            cell.numFmt = numFmtVar;
          }
        });

        cell.font = font;
        cell.alignment = alignment;

        if (isDate) {
          cell.value = new Date(text);
        } else if (isNumber) {
          cell.value = Number(text);
        } else {
          cell.value = text;
        }
      } else {
        cell.font = { name: "SansSerif", size: 9 };
        cell.alignment = { vertical: "top", horizontal: "left" };
      }
    });
    if (isBoldRow) {
      row.height = (row.height || 15) * 1.5;
    }
  });

  worksheet.columns.forEach((column) => {
    let maxLength = 0;
    column.eachCell({ includeEmpty: true }, (cell) => {
      const cellValue = cell.value ? cell.value.toString() : "";
      maxLength = Math.max(maxLength, cellValue.length);
    });
    column.width = maxLength + 2;
  });

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Resumo_${exportFilename}.xlsx`;
    link.click();
  });
};

export default extractExcelFunction;
